import { ICacheItem } from '../shared/localstorage.expirable.persistence.service';

export const IDB_NAME = 'casino';

export interface IIndexedDBCacheItem extends ICacheItem {
    cacheKey: string;
}

export interface ITableSchema {
    name: string;
    schema: string;
}

export const DBTableSchemas: ITableSchema[] = [
    {
        name: 'LobbyFeed',
        schema: 'cacheKey',
    },
];
